export var getDomainNameFromEmail = function (email) {
    // validate there is only 1 '@'
    var splitByAt = email.split('@');
    if (splitByAt.length === 2 && splitByAt[0] && splitByAt[1]) {
        return splitByAt[1];
    }
    return '';
};
